export interface ReportsState {
  freeTrialReport: FreeTrialReportState;
}

export interface FreeTrialReportState {
  loading: boolean;
}

export const reportsInitialState: ReportsState = {
  freeTrialReport: {
    loading: false
  }
};
